import { StyleSheet, Platform } from 'react-native';

const styles: any = StyleSheet.create({
	addPerson: {
		//color: '#438eb9',
		alignSelf: 'center'
		//marginLeft: 20
	},
	iconBtn: { justifyContent: 'center', width: 54 },
	footer: {
		backgroundColor: '#F8F8F8'
	},
	modalContainer: {
		flex: 1,
		justifyContent: 'center',
		backgroundColor: 'grey'
	},
	innerContainer: {
		alignItems: 'center'
	}
});
export default styles;
